import { render, staticRenderFns } from "./counter-add.vue?vue&type=template&id=6cc4e876&"
import script from "./counter-add.vue?vue&type=script&lang=js&"
export * from "./counter-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports